
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[market]/[language]/profiles/[collectionSlug]",
      function () {
        return require("private-next-pages/[market]/[language]/profiles/[collectionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[market]/[language]/profiles/[collectionSlug]"])
      });
    }
  